import { render, staticRenderFns } from "./ModalAlertText.vue?vue&type=template&id=fb567d2a&scoped=true&"
import script from "./ModalAlertText.vue?vue&type=script&lang=js&"
export * from "./ModalAlertText.vue?vue&type=script&lang=js&"
import style0 from "./ModalAlertText.vue?vue&type=style&index=0&id=fb567d2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb567d2a",
  null
  
)

export default component.exports